<template>
  <div class="traffic-block">
    <!-- 0.无接送  -->
    <!-- 1.有接：酒店 名、地址、丁文  -->
    <!-- 2.有接送：接地点 送回地点  -->
    <!-- 3.接机：  -->
    <!-- 4.送机：  -->

    <!------------------------------------------------- 无接送  ------------------------------------------------->
    <div v-if="this.traffic_type===0">
      <div class="traffic-type">
        <span class="traffic-title">
          无接送,需自行前往
          <i
            style="change-traffic-button"
            class="el-icon-setting"
            @click="changeTrafficType"
          ></i>
        </span>
      </div>
      <div class="traffic-info">
        交通说明：
        <br />
        {{traffic_info}}
      </div>
    </div>
    <!------------------------------------------------- 1.有接：酒店 名、地址、丁文  ------------------------------------------------->
    <div v-else-if="this.traffic_type===1">
      <div class="traffic-type">
        <span class="traffic-title">
          指定条件下，可安排酒店接
          <i
            style="change-traffic-button"
            class="el-icon-setting"
            @click="changeTrafficType"
          ></i>
        </span>
      </div>
      <div class="traffic-info">
        接送说明：
        <br />
        {{traffic_info}}
      </div>
    </div>
    <!------------------------------------------------- 2.有接送：接地点 送回地点  ------------------------------------------------->
    <div v-else-if="this.traffic_type===2">
      <div class="traffic-type">
        <span class="traffic-title">
          指定条件下，可安排酒店接送
          <i
            style="change-traffic-button"
            class="el-icon-setting"
            @click="changeTrafficType"
          ></i>
        </span>
      </div>
      <div class="traffic-info">
        接送说明：
        <br />
        {{traffic_info}}
      </div>
    </div>
    <!------------------------------------------------- 3.接机：  ------------------------------------------------->
    <div v-else-if="this.traffic_type===3">
      <div class="traffic-type">
        <span class="traffic-title">
          送机：酒店到机场
          <i
            style="change-traffic-button"
            class="el-icon-setting"
            @click="changeTrafficType"
          ></i>
        </span>
      </div>
      <div class="traffic-info">
        接送说明：
        <br />
        {{traffic_info}}
      </div>
    </div>
    <!------------------------------------------------- 4.送机：  ------------------------------------------------->
    <div v-else-if="this.traffic_type===4">
      <div class="traffic-type">
        <span class="traffic-title">
          接机：机场到酒店
          <i
            style="change-traffic-button"
            class="el-icon-setting"
            @click="changeTrafficType"
          ></i>
        </span>
      </div>
      <div class="traffic-info">
        接送说明：
        <br />
        {{traffic_info}}
      </div>
    </div>
    <!------------------------------------------------- 空：null  ------------------------------------------------->

    <div v-if="this.traffic_type===null">
      <div class="traffic-type">
        <span class="traffic-title">
          无接送,需自行前往
          <i
            style="change-traffic-button"
            class="el-icon-setting"
            @click="changeTrafficType"
          ></i>
        </span>
      </div>
      <div class="traffic-info">
        交通说明：
        <br />
        {{traffic_info}}
      </div>
    </div>
    <!-- ---------------------修改的对话框 : 方式选择 和说明-------------------------- -->
    <el-dialog :center="true" width="40%" :visible.sync="dialogChangeTrafficType">
      <el-form :model="formTrafficType">
        <el-form-item label="接送方式" :label-width="formLabelWidth">
          <el-select
            style="width:90%"
            size="mini"
            v-model="formTrafficType.type"
            placeholder="请选择交通类型"
          >
            <el-option label="无接送" value="0"></el-option>
            <el-option label="指定条件下，可安排酒店接" value="1"></el-option>
            <el-option label="指定条件下，可安排酒店接送" value="2"></el-option>
            <el-option label="送机" value="3"></el-option>
            <el-option label="接机" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="说明" :label-width="formLabelWidth">
          <el-input
            resize="none"
            rows="4"
            style="width:90%"
            size="mini"
            type="textarea"
            v-model="formTrafficType.info"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="cancleChangeTrafficType">取 消</el-button>
        <el-button size="mini" type="primary" @click="confirmChangeTrafficType">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import DividerLine from "../other/DividerLine";
export default {
  name: "traffic-modify",
  components: { "divider-line": DividerLine },
  data() {
    return {
      sku_id: this.attribuite,
      traffic_type: this.traffic_type_prop,
      traffic_info: this.traffic_info_prop,
      dialogChangeTrafficType: false,
      formLabelWidth: "100px",
      formTrafficType: {
        type: "请选择",
        info: this.traffic_info_prop,
      },
    };
  },
  props: {
    attribuite: null,
    traffic_info_prop: {
      type: String,
      default: "无",
    },
    traffic_type_prop: {
      type: Number,
      default: null,
    },
  },
  created() {},
  methods: {
    // 【对话框】出行方式与说明
    changeTrafficType() {
      console.log(this.formTrafficType);
      this.dialogChangeTrafficType = true;
      if (this.traffic_type_prop == 0) {
        this.formTrafficType.type = "无接送,需自行前往";
      } else if (this.traffic_type_prop == 1) {
        this.formTrafficType.type = "指定条件下，可安排酒店接";
      } else if (this.traffic_type_prop == 2) {
        this.formTrafficType.type = "指定条件下，可安排酒店接送";
      } else if (this.traffic_type_prop == 3) {
        this.formTrafficType.type = "送机：酒店到机场";
      } else if (this.traffic_type_prop == 4) {
        this.formTrafficType.type = "接机：机场到酒店";
      }
    },
    // 【确认】添加出行方式
    confirmChangeTrafficType() {
      if (this.formTrafficType.type == "无接送,需自行前往") {
        this.formTrafficType.type = 0;
      } else if (this.formTrafficType.type == "指定条件下，可安排酒店接") {
        this.formTrafficType.type = 1;
      } else if (this.formTrafficType.type == "指定条件下，可安排酒店接送") {
        this.formTrafficType.type = 2;
      } else if (this.formTrafficType.type == "送机：酒店到机场") {
        this.formTrafficType.type = 3;
      } else if (this.formTrafficType.type == "接机：机场到酒店") {
        this.formTrafficType.type = 4;
      }

      this.dialogChangeTrafficType = false;
      this.formTrafficType.sku_id = this.attribuite;

      this.$http
        .post("product/add_sku_traffic_type", this.formTrafficType)
        .then((res) => {
          console.log(res);
          const { data, errmsg, errno } = res.data;
          if (errno == "0") {
            this.traffic_type = parseInt(data.type);
            this.traffic_info = data.info;
          }
        });
    },
    cancleChangeTrafficType() {
      this.dialogChangeTrafficType = false;
    },
  },
};
</script>

<style>
.traffic-type {
  width: 100%;
  height: 100%;
  padding: 5px 10px;
  border-radius: 5px 5px 0px 0px;
}
.traffic-title {
  cursor: pointer;
  font-weight: bolder;
  width: 120%;
  border-top: 1px dashed gray;
  padding-top: 10px;
}
.traffic-info {
  padding: 5px 10px;
  width: 60%;
  height: 100%;
  border-radius: 0px 0px 5px 5px;
  white-space: pre-line;
  word-break: break-all;
}
.change-traffic-button {
  margin-left: 5px;
}
/* .traffic-type {
  width: auto;
  height: 100%;
  color: white;
  padding: 5px 10px;
  background-color: #ff9879;
  border: 1px solid #ff9879;
  border-radius: 5px 5px 0px 0px;
}
.traffic-info {
  padding: 5px 10px;
  width: auto;
  height: 100%;
  border: 1px solid #ff9879;
  border-radius: 0px 0px 5px 5px;
} */
</style>